export default "__VITE_ASSET__Lya3U1wH__"